export function sanitizeSearchTerm(term) {
  if (typeof term !== 'string') return ''
  return term
    .replace(/<[^>]*>/g, '')
    .replace(/[<>"';&$`\\]/g, '')
    .trim()
}

export function searchProducts(products, term, fields = ['name', 'id']) {
  const sanitized = sanitizeSearchTerm(term)
  if (!sanitized) return []

  const lowerTerm = sanitized.toLowerCase()

  return products.filter((product) =>
    fields.some((field) => {
      const value = product[field]
      return value && String(value).toLowerCase().includes(lowerTerm)
    })
  )
}
